import { render, staticRenderFns } from "./brandLibrary.vue?vue&type=template&id=56fb7cb6"
import script from "./brandLibrary.vue?vue&type=script&lang=js"
export * from "./brandLibrary.vue?vue&type=script&lang=js"
import style0 from "./brandLibrary.vue?vue&type=style&index=0&id=56fb7cb6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports